<template>
  <div class="cocreation__item__button__wrapper">
    <a v-if="button.url" :href="button.url" target="_blank">
      <SsButton2
        class="cocreation__item__button">
        <img v-if="button.icon" :src="button.icon" class="cocreation__item__button__icon">
        <span>{{ button.title }}</span>
        <i v-if="arrowVisible" class="ssCommunityIcon__arrowRight" />
      </SsButton2>
    </a>
    <SsButton2
      v-else
      class="cocreation__item__button"
      @click="onClick">
      <span>{{ button.title }}</span>
      <i v-if="arrowVisible" class="ssCommunityIcon__arrowRight" />
    </SsButton2>
    <div class="cocreation__item__button__reaction">
      <img
        :class="[{ bounce }]"
        :style="{'--randomRotate': `${bounceDeg}deg`}"
        :src="likeImages[randomIndex]"
        @animationend="onAnimationEnd"
      >
    </div>
  </div>
</template>

<script>
import SsButton2 from '../../SsButton2'
export default {
  name: 'CoCreationItemButton',

  components: {
    SsButton2
  },

  props: {
    button: Object,
    arrowVisible: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      randomIndex: 0,
      likeImages: [
        'https://cdn-static.sspai.com/ui/emoji/1_zan.png',
        'https://cdn-static.sspai.com/ui/emoji/6_haodongxi.png',
        'https://cdn-static.sspai.com/ui/emoji/2_chongdian.png',
        'https://cdn-static.sspai.com/ui/emoji/4_jiayi.png'
      ],
      bounce: false,
      bounceDeg: 0
    }
  },

  methods: {
    onClick () {
      if (this.button.eventHandler) {
        this.button.eventHandler(this.onReaction)
      }
    },
    onReaction () {
      const max = -90
      const min = 90
      this.randomIndex = this.$round(Math.random() * (this.likeImages.length - 1), 0, 'number')
      this.bounceDeg = this.$round(Math.random() * (max - min) + min, 2, 'number')
      this.bounce = true
    },
    onAnimationEnd () {
      this.bounce = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.cocreation__item__button__wrapper {
  position: relative;
}
.cocreation__item__button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  gap: 2px;
  z-index: 2;
  padding: var(--padding-CoCreationItemButton, (4px 8px));
  border-radius: var(--radius-CoCreationItemButton, 6px);
  background: var(--color-CoCreationItemButton-bg, var(--purple-t));
  font-size: var(--text-CoCreationItemButton, 13px);
  font-weight: var(--font-weight-CoCreationItemButton, 500);
  color: var(--color-CoCreationItemButton, #fff);
  .cocreation__item__button__icon {
    width: var(--size-CoCreationItemButton, 16px);
    height: var(--size-CoCreationItemButton, 16px);
    object-fit: contain;
  }
  .ssCommunityIcon__arrowRight {
    font-size: var(--size-CoCreationItemButtonIcon, 16px);
    font-weight: 400;
  }
}
.cocreation__item__button__reaction {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  img {
    opacity: 0;
    width: 24px;
    height: 24px;
  }
}
.bounce {
  animation: bangBounce 0.8s cubic-bezier(0,0,0,1) forwards;
}
@keyframes bangBounce {
  0% {
    opacity: 0;
    transform: rotate(var(--randomRotate));
  }
  10% {
    opacity: 1;
    transform: rotate(var(--randomRotate));
  }
  100% {
    opacity: 0;
    transform: rotate(var(--randomRotate)) translateX(80px) translateY(10px);
  }
}
</style>
